export const pageList = [
  { name: "Story", link: "/story" },
  { name: "Product", link: "/product" },
  // { name: "Event", link: "/event" },
  // 이노핏랩 체험 공간 없애면서 해당되는 페이지도 삭제.
  // { name: "innofitLab", link: "/lab" },
  { name: "PR", link: "/pr" },
  { name: "Membership", link: "/membership" },
];
